import React, {useState, useEffect} from 'react'
import axios from 'axios';
import DatePicker from 'react-datepicker';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const DueHistory = ({
      id,
  handleToast,
  closeLoading,
  handleLoading,
  toggleHeader,
}) => {
    const dateTwo = new Date();
  dateTwo.setDate(dateTwo.getDate() - 2);

    const [reports, setReports] = useState([]);
    const [filters, setFilters] = useState({
      g_name: "",
    });
    const [startDate, setStartDate] = useState(dateTwo);
    const [endDate, setEndDate] = useState(new Date());
    const [filteredReports, setFilteredReports] = useState([]);
  const [totalDueAmount, setTotalDueAmount] = useState("0.00");
  

  const fetchReports = async () => {
    handleLoading();

    try {
      const response = await axios.post(
        `https://api.dectwinhotel.com/api/${id}_due_payments/due-reports`,
        {
          startDate,
          endDate,
        }
      );
      closeLoading();
      handleToast({
        toastMsg: "Reports Fetched Successfully!!!",
        toastColor: "#4CAF50",
      });

       const sortedData = response.data.sort((a, b) => {
      return Number(a.inv_no) - Number(b.inv_no);
    });

      setReports(sortedData);
      console.log(response.data);
      setFilteredReports(sortedData);
    } catch (err) {
      if (err.code === "ECONNABORTED") {
        fetchReports();
      }
      handleToast({
        toastMsg: "Something went wrong! Please try again",
        toastColor: "#FF0000",
      });
      closeLoading();
    }
  };


const getGuestCompanyAndNames = (guestIdsJson, guestsArray) => {
  try {
    const guestData = JSON.parse(guestIdsJson);
    const allGuestNames = guestData.name || [];

    let company = "";
    let guests = [];

    if (guestsArray?.[0]?.is_com === 1) {
      // Company exists
      const firstName = allGuestNames[0];
      const parts = firstName.split(',');
      company = parts[0].trim(); // company name
      guests = allGuestNames.map(name => {
        const splitParts = name.split(',');
        return splitParts[1]?.trim() || splitParts[0].trim();
      });
    } else {
      // No company, all names are guests
      guests = allGuestNames.map(name => name.trim());
    }

    return { company, guests };
  } catch (e) {
    console.error("Invalid guest_ids JSON:", guestIdsJson);
    return { company: "", guests: [] };
  }
};


const handleFilterChange = (e) => {
  const { value } = e.target;
  setFilters((prev) => ({
    ...prev,
    g_name: value,
  }));
};

// Filter reports whenever reports or filters change
useEffect(() => {
  if (!filters.g_name) {
    setFilteredReports(reports);
    return;
  }

  const filtered = reports.filter((report) => {
    const { company, guests } = getGuestCompanyAndNames(report.guest_ids, report.guests);
    const searchTerm = filters.g_name.toLowerCase();

    // Check company name and all guest names
    const companyMatch = company.toLowerCase().includes(searchTerm);
    const guestMatch = guests.some((g) => g.toLowerCase().includes(searchTerm));

    return companyMatch || guestMatch;
  });

  setFilteredReports(filtered);
}, [filters.g_name, reports]);


  useEffect(() => {

  const dueAmount = filteredReports
    .reduce(
      (sum, booking) =>
        sum +
          parseFloat(booking.amount || 0),
      0
    )
    .toFixed(2);

  setTotalDueAmount(dueAmount);
}, [filteredReports]);


const exportToExcel = () => {
  if (filteredReports.length === 0) {
    handleToast({
      toastMsg: "No data available to export",
      toastColor: "#FF0000",
    });
    return;
  }

  // Prepare rows for Excel
  const excelData = filteredReports.map((report, index) => {
    const { company, guests } = getGuestCompanyAndNames(
      report.guest_ids,
      report.guests
    );

    return {
      "S.No": index + 1,
      "Booking ID": report.inv_no ?? report.booking_id,
      "Company Name": company || "--",
      "Guest Names": guests.join(", "),
      "Room No": report.room_no || "--",
      "Collected On": new Date(report.collected_on).toLocaleString(),
      "Due Amount": Number(report.amount || 0).toFixed(2),
      "Payment Mode": report.due_method || "--",
      "Remarks": report.due_remark || "--",
    };
  });

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Due-History-Report");

  // Auto column width
  const columnWidths = Object.keys(excelData[0]).map((key) => ({
    wch: Math.max(
      key.length,
      ...excelData.map((row) => String(row[key]).length)
    ) + 2,
  }));
  worksheet["!cols"] = columnWidths;

  // Export file
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(blob, `Due-History-Report_${Date.now()}.xlsx`);
};


  return (
    <>
    <section
      style={{
        backgroundColor: "#282c34",
        padding: "4rem 1rem",
      }}
    >
        <div className="reports-page">

<div className='d-flex justify-content-between'>
          <h2 className="text-start my-0">Due Payments History</h2>

            <button
              style={{ backgroundColor: "#008800", marginLeft: "20px" }}
              className="fetch-btn"
              onClick={exportToExcel}
            >
              Download Excel &nbsp; <i className="fas fa-file-excel"></i>
            </button>
</div>
{/* flex ends */}

          <div className="row my-3">
            <div className="col-lg-4 col-12 my-2">
              <label>Date Range:</label>
              <div className="date-picker">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
  dateFormat="dd/MM/yyyy"                />
                <span>to</span>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
  dateFormat="dd/MM/yyyy"                />
              </div>
            </div>

            <div className="col-lg-4 col-12 my-2">
              <label>Guest/ Company Name:</label>
              <input
                type="text"
                name="g_name"
                value={filters.g_name}
                onChange={handleFilterChange}
                placeholder="Enter Here"
              />
            </div>


            <div className="col-lg-4 col-12 my-2 pt-4">
              <button className="fetch-btn mt-2" onClick={fetchReports}>
                Fetch Reports
              </button>
            </div>
          </div>

<p className="col-lg-9 mb-2" style={{fontWeight: "bold", margin: 0 }}>
  Total (Due Collection): ₹{totalDueAmount}
</p>


          {reports.length > 0 && (
            <div className="table-responsive">
              <table className="reports-table">
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Company Name</th>
                    <th>Guest Info</th>
                    <th>Room No</th>
                    <th>Collected On</th>
                    <th>Due Amount</th>
                    <th>Payment Mode</th>
                    <th>Remarks (If Any)</th>
                    {/* <th>GST Amount</th>
                    <th>Total Amount</th> */}
                  </tr>
                </thead>
                <tbody>
                  {filteredReports.map((report) => (
                    <tr key={report.id}>
                      <td>{report.inv_no ?? report.booking_id}</td>
{(() => {
  const { company, guests } = getGuestCompanyAndNames(report.guest_ids, report.guests);
  return (
    <>
      <td>{company}</td>
      <td>{guests.join(', ')}</td>
    </>
  );
})()}

                      <td>{report.room_no}</td>
                      <td>{new Date(report.collected_on).toLocaleString()}</td>
                      <td>₹{report.amount}</td>
                      <td>{report.due_method}</td>
                      <td>{report.due_remark || '--'}</td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}


          </div>
          </section>
</>
  )
}

export default DueHistory